<template>
    <b-modal ref="mdlConsensiProfiliComponent" size="lg" title="Associa Consenso Profilo" no-close-on-backdrop
        no-close-on-esc centered scrollable>
        <div class="sa-tab-scroll">
            <div class="sa-prescrizione-card">
                <div class="sa-prescrizione-header">
                    <div class="header-left">
                        <div class="sa-prescrizione-header-title">{{ consenso.nomeConsenso }}</div>
                        <div class="sa-prescrizione-header-subtitle">{{ getDescrizioneConsenso(consenso) }}</div>
                    </div>
                    <div class="header-right">
                        <div class="kt-card-box">
                            <span class="kt-card-label" style="color:white">Associa Gruppo</span>
                            <span class="kt-card-data">
                                <b-form-input list="my-list-id" v-model="gruppo"></b-form-input>
                                <datalist id="my-list-id">
                                    <option v-for="(item, i) in gruppiItems" :key="i">
                                        {{ `${item.nome} ` }}
                                    </option>
                                </datalist>
                                <button class="kt-btn-add-floating" @click="onAggiungiAssociazione()">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="sa-prescrizione-body">
                    <b-row v-if="consensiGruppiItems.length > 0">
                        <b-col cols="12" md="6" lg="4" v-for="(item, index) in consensiGruppiItems" :key="index">
                            <div class="kt-card">
                                <div class="kt-card-body">
                                    <div class="kt-card-box-centered">
                                        <span class="kt-card-label">Gruppo</span>
                                        <span class="kt-card-data">{{ item.gruppoDescrizione }}</span>
                                    </div>
                                </div>
                                <button class="kt-btn-remove-floating" @click="onRemoveAssociazione(item)">
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col>
                            <div class="kt-vuoto">
                                <i class="fas fa-user-slash kt-vuoto-icon"></i>
                                <div class="kt-vuoto-title">Nessun profilo associato</div>
                                <div class="kt-vuoto-subtitle">
                                    Non ci sono profili associati a questo consenso al momento.
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-prescrizione-footer">
                    <div class="sa-prescrizione-total-text">
                        <!-- Volume Finale: <span class="sa-prescrizione-total-value">{{ totalVolume }} ml</span> -->
                    </div>

                </div>
            </div>

        </div>
    </b-modal>
</template>

<script>

import toast from "../../../template/layout/utility/sa-toast";
import GruppoMixins from "../../utenti/mixins/GruppoMixins"
import ConsensiGruppiAssociazioneMixins from "../mixins/ConsensiGruppiAssociazioneMixins"

export default {
    mixins: [GruppoMixins, ConsensiGruppiAssociazioneMixins],
    data() {
        return {
            consenso: {},
            gruppo: null,
            localData: {
                consensoId: null,
                gruppoId: null,
                gruppoDescrizione: null,
            },
            test: [{ consensiId: "1", gruppoId: "1" }, { consensiId: "1", gruppoId: "1" }, { consensiId: "1", gruppoId: "1" }]
        }
    },
    methods: {
        init(consenso) {
            this.consenso = consenso;
            this.show();
            this.loadDataDefault();
            this.filter.consenso = consenso.id;
            this.localData.consensoId = consenso.id;
            this.loadData();
        },
        loadData() {
            this.gruppiConsensiLoadData();
        },
        show() {
            this.$refs.mdlConsensiProfiliComponent.show();
        },
        hide() {
            this.$refs.mdlConsensiProfiliComponent.hide();
        },
        resetLocalData() {
            this.localData = {
                consensoId: this.consenso.id,
                gruppoId: null,
                gruppoDescrizione: null,
            }
        },
        loadDataDefault() {
            this.gruppiLoadData();
        },
        getDescrizioneConsenso(consenso) {
            let returnValue = consenso.descrizione;
            if (!consenso.descrizione) {
                returnValue = ""
            }
            return returnValue
        },
        onRemoveAssociazione(associazione) {
            this.eliminaAssociazione(associazione, () => {
                this.resetLocalData();
                this.loadData();
            });
        },
        onAggiungiAssociazione() {
            console.log(this.gruppo);
            if (!this.gruppo) {
                this.generaToast();
                this.gruppo = null;
                return;
            }
            let filter = this.gruppiItems.filter(e => e.nome == this.gruppo);
            if (filter.length == 0) {
                this.generaToast();
                this.gruppo = null;
                return;
            }
            let gruppoId = filter[0].id;
            let gruppoNome = filter[0].nome;
            this.localData.gruppoId = gruppoId;
            this.localData.gruppoDescrizione = gruppoNome;
            this.salvaAssociazione(this.localData, () => {
                this.resetLocalData();
                this.loadData();
            });
        },
        generaToast() {
            toast.error({ message: "Errore nella selezione del gruppo ripetere selezione!", title: "Attenzione" });
        }
    },

}
</script>

<style lang="scss" scoped>
.kt-wrapper-btn {
    display: flex;
    justify-content: center;
    padding: 2px;
}

.header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 50%;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 100%;
}

.kt-card {
    position: relative;
    background: #ffffff;
    border-radius: 14px;
    padding-bottom: 12px;
    box-shadow: 0 0 30px rgba(82, 63, 105, 0.06);
    border: 0.5px solid #b9babe91;
    transition: all 0.3s ease;
    height: 100%;
}

.kt-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 40px rgba(82, 63, 105, 0.15);
    border: 1px solid var(--bg-sidebar);
}

.kt-card-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.kt-card-box {
    display: flex;
    flex-direction: column;
}

.kt-card-box-centered {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.kt-card-label {
    font-size: 11px;
    font-weight: 600;
    color: #7e8299;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.kt-card-data {
    font-size: 15px;
    font-weight: 500;
    color: #181c32;
}

.kt-btn-remove-floating {
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translateX(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: #f1416c;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(241, 65, 108, 0.45);
    cursor: pointer;
    opacity: 0;
    transition: all 0.25s ease;
}

.kt-btn-add-floating {
    position: relative;
    left: 50%;
    top: 5px;
    transform: translateX(-50%);
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: none;
    background: #218838;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 10px #12491e;
    cursor: pointer;
    opacity: 1;
    transition: all 0.25s ease;
}

.kt-btn-add-floating:hover {
    background: #28a745;
    transform: translateX(-50%) scale(1.1);
    box-shadow: 0 5px 12px #27853d;
}

.kt-btn-add-floating i {
    font-size: 10px !important;
}

.kt-card:hover .kt-btn-remove-floating {
    opacity: 1;
    bottom: -14px;
    right: 12px;
}

.kt-btn-remove-floating:hover {
    background: #d9214e;
    transform: translateX(-50%) scale(1.1);
}

.kt-vuoto {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background-color: #f8f9fa;
    /* grigio chiaro */
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    text-align: center;
    color: #6c757d;
}

.kt-vuoto-icon {
    font-size: 36px;
    color: #d1d3e0;
    margin-bottom: 16px;
}

.kt-vuoto-title {
    font-size: 18px;
    font-weight: 600;
    color: #181c32;
    margin-bottom: 8px;
}

.kt-vuoto-subtitle {
    font-size: 14px;
    color: #7e8299;
}

datalist option {
    font-size: 14px;
    padding: 4px 8px;
}
</style>